import { getTaobaoItemListSku } from "@/api/jhk/analysis/ware-controller";

// 活动详情处理参数
export const setBasicInformation = (data, that) => {
  const {
    activityName,
    startTime,
    endTime,
    ruleDto,
    isExposureItem,
    ruleDescription,
    allowLevel,
    crowdIds,
    condFollow,
    templateId,
    isKeyActivity,
    placementPosition,
    isValidBlackList,
    itemList,
    templateJson,
  } = data;
  const {
    openCardFollow,
    firstOpenCardTimeType,
    openCardBeforeDay,
    isForceRemind,
    customerPaperwork,
    isCommentLimit,
    shareTitle,
    shareIntroduce,
    sharePic,
    goShopSetting,
    goShopAppId,
    goShopUrl,
  } = ruleDto;
  that.ruleForm.goShopSetting = goShopSetting;
  that.ruleForm.goShopUrl = goShopUrl;
  that.ruleForm.goShopAppId = goShopAppId;
  that.ruleForm.shareTitle = shareTitle;
  that.ruleForm.shareIntroduce = shareIntroduce;
  that.ruleForm.sharePic = sharePic;
  that.ruleForm.activityName =
    activityName + (that.activityData.isCopy ? "复制" : "");
  that.ruleForm.condFollow = condFollow ? true : false;
  if (allowLevel == "99") {
    that.peopleSelected = crowdIds.split(",");
    that.actMember = "3";
  } else if (allowLevel == "-1") {
    that.actMember = "1";
    that.ruleForm.partner = ["-1"];
  } else {
    that.actMember = "2";
    if (allowLevel.indexOf("-1") != -1) {
      that.ruleForm.partner = ["-1"];
    } else {
      that.ruleForm.partner = allowLevel.split(",");
    }
  }
  that.ruleForm.openCardFollow = openCardFollow;
  that.ruleForm.isValidBlackList = isValidBlackList;
  that.ruleForm.firstOpenCardTimeType = firstOpenCardTimeType;
  that.ruleForm.openCardBeforeDay = openCardBeforeDay;
  that.ruleDTO = ruleDto;
  that.isKeyActivity = isKeyActivity || 0;
  that.placementPosition = placementPosition
    ? placementPosition.split(",")
    : ["SHOP"];
  that.ruleForm.orderCompleteLimitCount = ruleDto.orderCompleteLimitCount;
  that.ruleForm.orderCompleteMaxCount = ruleDto.orderCompleteMaxCount;
  that.ruleForm.orderCompleteLimitPayment = ruleDto.orderCompleteLimitPayment;
  that.ruleForm.orderCompleteMaxPayment = ruleDto.orderCompleteMaxPayment;
  that.ruleForm.lastOrderCompleteTimeType =
    ruleDto.lastOrderCompleteTimeType || 0;
  that.ruleForm.lastOrderCompleteStartDay = ruleDto.lastOrderCompleteStartDay;
  that.ruleForm.lastOrderCompleteEndDay = ruleDto.lastOrderCompleteEndDay;
  that.ruleForm.lastOrderCompleteStartTime = ruleDto.lastOrderCompleteStartTime;
  that.ruleForm.lastOrderCompleteEndTime = ruleDto.lastOrderCompleteEndTime;
  that.templateJson = JSON.parse(templateJson);
  if (customerPaperwork) {
    that.customerPaperwork = JSON.parse(customerPaperwork);
  }
  if (!that.activityData.isCopy) {
    that.ruleForm.startTime = startTime;
    that.ruleForm.endTime = endTime;
    that.activityStartTime = startTime;
    that.activityEndTime = endTime;

    // that.ruleForm.isExposureItem = isExposureItem ? true : false;
    // that.itemListFor = itemList;
    // that.ruleForm.ruleDescription = ruleDescription;
  }
  if (that.activityData.isCopy) {
    // that.ruleForm.ruleDescription = "";
  }
  that.templateId = templateId;

  that.questionList = data.questions;
  that.recommendProducts = data.recommendProducts.map((item) => {
    return {
      ...item,
      jdPrice: item.price || null,
      couponObject: {
        sort: null,
        assetsId: null, // 资产项id(计划id优惠卷id商品id)
        prizeType: null, // 类型 固定为实物
        price: null, // 价格
        title: "", // 商品标题
        totalAmount: null, // 总共奖品数量
        singleAmount: 1, // 单份奖品数量 固定为1
        logo: null, // 自定义商品图片
        giftType: 1, //实物类型
        prizeObjectType: 10, //正装商品
        percentage: null, // 中奖率
        isShow: 1,
      },
    };
  });
  that.fallbackProducts = ruleDto.fallbackProducts.map((item) => {
    return {
      ...item,
      jdPrice: item.price || null,
    };
  });
  if(that.ruleDTO.couponMode == 1){
    that.formalTable = data.pointActivityPrizeDTOList || [
        {
          sort: 0,
          assetsId: null, // 资产项id(计划id优惠卷id商品id)
          prizeType: null, // 类型 固定为实物
          price: null, // 价格
          title: "", // 商品标题
          totalAmount: null, // 总共奖品数量
          singleAmount: 1, // 单份奖品数量 固定为1
          logo: null, // 自定义商品图片
          giftType: 1, //实物类型
          prizeObjectType: 10, //正装商品
          percentage: null, // 中奖率
          isShow: 1
        },
    ];
  }
  if(that.ruleDTO.couponMode == 2 && data.pointActivityPrizeDTOList){
    data.pointActivityPrizeDTOList.forEach((item) => {
        that.recommendProducts.forEach((product) => {
            if(product.skuId == item.skuIds){
                product.couponObject = item;
            }
        })
    })
  }
};
// 修改活动入参
export const useUpdateBasicInformation = (obj, prizeListCommon, that) => {
  console.log("prizeListCommon", prizeListCommon);
  let prizeListCommonNew = prizeListCommon || [];
  let params = {
    activityId: that.valueRow.id,
    ruleDescription: obj.ruleDescription,
    prizes: prizeListCommonNew
      .filter((item) => item.id)
      .map((item) => {
        return {
          ...item,
          prizeId: item.id,
        };
      }),
    activityName: obj.activityName,
    condFollow: obj.condFollow ? 1 : 0,
    ruleDto: obj.ruleDTO,
    templateId: that.templateId,
    endTime: that.ruleForm.endTime,
    isValidBlackList: obj.isValidBlackList,
    addPrizeDTOList:  prizeListCommonNew
      .filter((item) => !item.id)
      .map((item) => {
        return {
          ...item,
          prizeId: item.id,
        };
      }),
    questions: obj.questions,
    recommendProducts: obj.recommendProducts,
  };
  if(obj.subType==87) {
    params.firstItemList = that.firstItemList
  }
  return params;
};